if (window.location.href.indexOf("gift-inflatable-tub") > -1) {
  window.location.replace("/");
};

/* Script Load Cart */
$('.open-cart-rebuy').click(function () {
  cartLoad();
});

function cartLoad() {
  if (typeof Rebuy === 'undefined' || typeof Rebuy.SmartCart === 'undefined' || typeof Rebuy.SmartCart.show !== 'function') {
    RebuyPreload();
  } else {
    Rebuy.SmartCart.show();
  };
};

function RebuyPreload() {
  $('body').addClass('show-cart-preload');
};

function cartReady() {
  if ($('body').hasClass('show-cart-preload')) {
    setTimeout(function () {
      $('body').removeClass('show-cart-preload');
      Rebuy.SmartCart.show();
    }, 1000);
  };
};

/* Script Render Ticker */
function RenderTickerRebuy() {
  $('.rebuy-cart__flyout').append(
    '<div class="rebuy-cart__ticker-bar">' +
    '<div class="rebuy-cart-ticker-bar__container">' +
    '<div class="rebuy-cart-ticker-bar__messages">' +
    '<ul>' +
    '<li class="rebuy-cart-ticker-bar__message"><span class="rebuy-cart-ticker-bar__message-text">Free US Shipping</span></li>' +
    '<li class="rebuy-cart-ticker-bar__message"><span class="rebuy-cart-ticker-bar__message-text">Satisfaction Guaranteed</span></li>' +
    '<li class="rebuy-cart-ticker-bar__message"><span class="rebuy-cart-ticker-bar__message-text">Enjoy 0% APR Financing for 12 Months</span></li>' +
    '</ul>' +
    '</div>' +
    '</div>' +
    '</div>'
  );

  $('.rebuy-cart__flyout-footer').append(
    '<div class="rebuy-cart__questions">' +
    '<div class="rebuy-cart__questions__container">' +
    '<p>Got any questions? Give us a call!</p>' +
    '<a href="tel:+18884147363" target="_blank">(+1) 888-414-7363</a>' +
    '</div>' +
    '</div>'
  );

  var elementsRebuy = $(".rebuy-cart__flyout .rebuy-cart__ticker-bar .rebuy-cart-ticker-bar__messages ul li");
  var elementsCloneRebuy = $();

  elementsRebuy.each(function () {
    var elementRebuy = $(this);
    var elementCloneRebuy = elementRebuy.clone();
    elementsCloneRebuy = elementsCloneRebuy.add(elementCloneRebuy);
  });

  elementsRebuy.each(function () {
    var indice = elementsRebuy.index(this);
    for (var i = 0; i < 20; i++) {
      $(".rebuy-cart__flyout .rebuy-cart__ticker-bar .rebuy-cart-ticker-bar__messages ul").append(elementsCloneRebuy.clone());
    }
  });

  $('.rebuy-cart__flyout .rebuy-cart__ticker-bar .rebuy-cart-ticker-bar__messages').jConveyorTicker({
    anim_duration: 200,
    force_loop: true
  });
};

/* Script Render Button Loading */
function ButtonLoading() {
  $('div#rebuy-cart .rebuy-cart__flyout-footer .rebuy-cart__checkout-button').before(
    '<div class="btn-loading-rebuy-cart">' +
    '<span class="button button--primary button--full">' +
    '<div class="load-more__spinner-variants"></div>' +
    '</span>' +
    '</div>'
  );
};

/* Script Product Ready Variants */
function ProductReady() {
  setTimeout(function () {
    $('.container-button-load__product').hide();
    $('.product-form__buy-buttons').show();
    console.log('Variants Ready');
  }, 3000);
};

/* Script Add INFLATABLE */
function $giftWithPurchase(products) {
  function gift(productId) { return productId.product_id === 7231352963204; }; var validationGift = products.find(gift);
  function portal(productId) { return productId.product_id === 6710391308420; }; var validationPortal = products.find(portal);
  function brainpod(productId) { return productId.product_id === 6710388949124; }; var validationBrainpod = products.find(brainpod);
  function starTreatment(productId) { return productId.product_id === 7198625267844; }; var validationStarTreatment = products.find(starTreatment);

  if (validationGift !== undefined) {
    var qtyGift = validationGift.quantity;

    if (validationPortal !== undefined || validationBrainpod !== undefined || validationStarTreatment !== undefined) {
      if (qtyGift > 1) {
        jQuery.post('/cart/update.js', {
          updates: {
            41749757952132: 1
          }
        });
      };
    } else {
      jQuery.post('/cart/update.js', {
        updates: {
          41749757952132: 0
        }
      });
    };
  } else {
    if (validationPortal !== undefined || validationBrainpod !== undefined || validationStarTreatment !== undefined) {
      var dataGift = {
        "id": 41749757952132,
        "quantity": 1
      }

      jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: dataGift,
        dataType: 'json',
        success: function () {
          console.log('🟢🟢🟢🟢 GIFT ADDED.');
        }
      });
    };
  };
};

/* Script Events Rebuy */
document.addEventListener('rebuy:smartcart.ready', function (event) {
  console.log('rebuy:smartcart.ready event', event.detail);
  // RenderTickerRebuy();
  ButtonLoading();
  ProductReady();
  cartReady();

  /* const products = event.detail.smartcart.cart.items;
  $giftWithPurchase(products); */
});

document.addEventListener('rebuy:cart.change', function (event) {
  console.log('rebuy:rebuy:cart.change event', event.detail);
  var $qty_rebuy = event.detail.cart.cart.item_count;
  $('cart-count.header__cart-count').text($qty_rebuy);

  /* const products = event.detail.cart.cart.items;
  $giftWithPurchase(products); */

  setTimeout(function () {
    $('#rebuy-cart .rebuy-cart__flyout-footer .btn-loading-rebuy-cart').hide();
    $('#rebuy-cart .rebuy-cart__flyout-footer .rebuy-cart__checkout-button').show();
  }, 1000);
});

document.addEventListener("rebuy:smartcart.line-item-removed", (event) => {
  $('#rebuy-cart .rebuy-cart__flyout-footer .rebuy-cart__checkout-button').hide();
  $('#rebuy-cart .rebuy-cart__flyout-footer .btn-loading-rebuy-cart').show();
});
